import React from 'react';
import { EntityLayout } from '@backstage/plugin-catalog';
import { RTLLinksCard } from '../../cards/LinksCard';
import { Grid } from '@material-ui/core';
import { RTLCatalogGraphCard } from '../../cards/CatalogGraphCard';
import { HasSystemsCard } from '../../cards/HasSystemsCard';
import { WarningCard } from '../../cards/WarningCard';
import { RTLAboutCard } from '../../cards/AboutCard';
import { HasComponentsCard } from '../../cards/HasComponentsCard';
import { HasApisCard } from '../../cards/HasApisCard';
import { HasProductsCard } from '../../cards/HasProductCard';
import { SystemContextDiagramCard } from '../../cards/SystemContextDiagramCard';
import { ContainerDiagramCard } from '../../cards/ContainerDiagramCard';
import { DeploymentDiagramCard } from '../../cards/DeploymentDiagramCard';
import { featureFlagsApiRef, useApi } from '@backstage/core-plugin-api';
import { isAdrAvailable } from '@backstage-community/plugin-adr';
import { AdrContent } from '../AdrContent';

export const SystemPage = () => {
  const featureFlagsApi = useApi(featureFlagsApiRef);

  return (
    <EntityLayout>
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3} alignItems="stretch">
          <WarningCard />
          <Grid item md={6} xs={12}>
            <RTLAboutCard />
          </Grid>
          <Grid item md={6} xs={12}>
            <RTLCatalogGraphCard height={400} />
          </Grid>
          <RTLLinksCard />
          <Grid item xs={12}>
            <HasSystemsCard />
          </Grid>
        </Grid>
      </EntityLayout.Route>
      <EntityLayout.Route path="/components" title="Components">
        <Grid container spacing={3} alignItems="stretch">
          <Grid item xs={12}>
            <HasComponentsCard />
          </Grid>
        </Grid>
      </EntityLayout.Route>
      <EntityLayout.Route path="/apis" title="APIs">
        <Grid container spacing={3} alignItems="stretch">
          <Grid item xs={12}>
            <HasApisCard />
          </Grid>
        </Grid>
      </EntityLayout.Route>
      <EntityLayout.Route path="/products" title="Products">
        <Grid container spacing={3} alignItems="stretch">
          <Grid item xs={12}>
            <HasProductsCard />
          </Grid>
        </Grid>
      </EntityLayout.Route>
      <EntityLayout.Route path="/context" title="System-Context-Diagram">
        <SystemContextDiagramCard />
      </EntityLayout.Route>
      <EntityLayout.Route path="/container" title="Container-Diagram">
        <ContainerDiagramCard />
      </EntityLayout.Route>
      <EntityLayout.Route
        path="/deployment"
        title="Deployment-Diagram"
        if={_ => featureFlagsApi.isActive('c4-deployment-diagram')}
      >
        <DeploymentDiagramCard />
      </EntityLayout.Route>
      <EntityLayout.Route path="/adrs" title="ADRs" if={isAdrAvailable}>
        <AdrContent />
      </EntityLayout.Route>
    </EntityLayout>
  );
};
